import Ask from "../components/Ask";
import Navbar from "../components/Navbar";
import PrevQues from "../components/PrevQues";
import ChemistDashboard from "../components/ChemistDashboard";
import { useContext, useEffect, useState } from "react";
import languageContext from "../context/language/languageContext";



const QuestionPage = () => {
    const {isLeftPanel, setIsLeftPanel } = useContext(languageContext);
    // const bookAppointment = location.state?.book_appointment;
    // const  Checklist= location.state?.Checklist;

    

    useEffect(()=>{
        const resizeHandler = () => setIsLeftPanel(false);
        window.addEventListener("resize", resizeHandler);

        return ()=>{
            window.removeEventListener("resize", resizeHandler);
        }
    },[])
    return (
        <div className="flex flex-col h-[100vh] "> {/* Ensure full screen height */}
            <Navbar />
                <div className="w-full overflow-y-auto"> {/* Make this section scrollable */}
                <ChemistDashboard/>
               {/* < DoctorPatientDashboard/> */}
                </div>
            </div>
    );
}

export default QuestionPage;